import { CheckCircle2, User, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

const ROL_LABEL = {
  admin: 'Administrador',
  supervisor: 'Supervisor',
  maestro: 'Maestro',
  ejecutivo: 'Ejecutivo',
  gerencia: 'Gerencia',
};

export default function MiPerfilModal({ ejecutivo, onClose, onActualizado }) {
  const [nombre, setNombre]       = useState(ejecutivo?.nombre ?? '');
  const [telefono, setTelefono]   = useState(ejecutivo?.telefono ?? '');
  const [direccion, setDireccion] = useState(ejecutivo?.direccion ?? '');
  const [especialidad, setEspecialidad] = useState(ejecutivo?.especialidad ?? '');
  const [notas, setNotas]         = useState(ejecutivo?.notas_perfil ?? '');
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState(null);
  const [exito, setExito]         = useState(false);

  useEffect(() => {
    function onEsc(e) { if (e.key === 'Escape') onClose?.(); }
    document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [onClose]);

  async function guardar(e) {
    e?.preventDefault?.();
    if (!nombre.trim()) { setError('El nombre es obligatorio'); return; }
    setLoading(true);
    setError(null);
    const { error: err } = await supabase
      .from('ejecutivos')
      .update({
        nombre:       nombre.trim(),
        telefono:     telefono.trim() || null,
        direccion:    direccion.trim() || null,
        especialidad: especialidad.trim() || null,
        notas_perfil: notas.trim() || null,
      })
      .eq('id', ejecutivo.id);
    setLoading(false);
    if (err) { setError(err.message); return; }
    setExito(true);
    onActualizado?.();
    setTimeout(() => onClose?.(), 1200);
  }

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 20,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: 'var(--bg-card)', borderRadius: 12, padding: 24,
        width: '100%', maxWidth: 460, border: '0.5px solid var(--border-200)',
        maxHeight: '90vh', overflowY: 'auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 18, color: 'var(--text-strong)' }}><User size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /> Mi perfil</h2>
          <button type="button" onClick={onClose} disabled={loading}
            style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--ink-400)' }}><X size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /></button>
        </div>

        {/* Campos solo lectura */}
        <div style={{ background: 'var(--bg-muted)', borderRadius: 8, padding: 12, marginBottom: 14 }}>
          <ReadOnlyField label="Email" value={ejecutivo?.email ?? '—'} hint="Para cambiar el email contacta a tu admin." />
          <ReadOnlyField label="Rol" value={ROL_LABEL[ejecutivo?.rol] ?? ejecutivo?.rol ?? '—'} />
          <ReadOnlyField label="Inmobiliaria" value={ejecutivo?.inmobiliaria?.nombre_empresa ?? '—'} noBorder />
        </div>

        <form onSubmit={guardar}>
          <Field label="Nombre completo *">
            <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} disabled={loading}
              style={fieldInput} />
          </Field>
          <Field label="Teléfono">
            <input type="tel" value={telefono} onChange={e => setTelefono(e.target.value)} disabled={loading}
              placeholder="+56 9 1234 5678" style={fieldInput} />
          </Field>
          <Field label="Dirección">
            <input type="text" value={direccion} onChange={e => setDireccion(e.target.value)} disabled={loading}
              placeholder="Opcional" style={fieldInput} />
          </Field>
          {(ejecutivo?.rol === 'supervisor' || ejecutivo?.rol === 'maestro') && (
            <Field label="Especialidad">
              <input type="text" value={especialidad} onChange={e => setEspecialidad(e.target.value)} disabled={loading}
                placeholder="ej. Estructural, Sanitario, Pintura" style={fieldInput} />
            </Field>
          )}
          <Field label="Notas (opcional)">
            <textarea rows={2} value={notas} onChange={e => setNotas(e.target.value)} disabled={loading}
              style={{ ...fieldInput, resize: 'vertical' }} />
          </Field>

          {error && (
            <div style={{
              padding: '8px 12px', background: 'var(--sev-critico-bg)', color: 'var(--sev-critico)',
              borderRadius: 6, fontSize: 12, marginBottom: 10,
            }}>{error}</div>
          )}
          {exito && (
            <div style={{
              padding: '8px 12px', background: 'var(--sev-ok-bg, #dcfce7)', color: 'var(--sev-ok, #15803d)',
              borderRadius: 6, fontSize: 12, marginBottom: 10,
            }}><CheckCircle2 size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /> Perfil actualizado</div>
          )}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" onClick={onClose} disabled={loading}
              style={{ padding: '8px 14px', border: '0.5px solid var(--border-200)', borderRadius: 6,
                background: 'transparent', color: 'var(--ink-400)', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit' }}>
              Cancelar
            </button>
            <button type="submit" disabled={loading || exito}
              style={{ padding: '8px 14px', border: 'none', borderRadius: 6,
                background: 'var(--accent, #FF6428)', color: 'white', fontSize: 13,
                cursor: loading ? 'wait' : 'pointer', fontFamily: 'inherit', opacity: (loading || exito) ? 0.6 : 1 }}>
              {loading ? 'Guardando…' : exito ? '✓' : 'Guardar cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const fieldInput = {
  width: '100%', padding: '9px 11px',
  border: '0.5px solid var(--border-200)', borderRadius: 6,
  background: 'var(--bg-app)', color: 'var(--text-strong)', fontSize: 14,
  fontFamily: 'inherit', boxSizing: 'border-box',
};

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <label style={{ display: 'block', fontSize: 12, color: 'var(--ink-500)', marginBottom: 5 }}>{label}</label>
      {children}
    </div>
  );
}

function ReadOnlyField({ label, value, hint, noBorder }) {
  return (
    <div style={{
      padding: '8px 0',
      borderBottom: noBorder ? 'none' : '0.5px solid var(--border-200)',
    }}>
      <div style={{ fontSize: 11, color: 'var(--ink-400)', marginBottom: 2, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        {label}
      </div>
      <div style={{ fontSize: 13, color: 'var(--text-strong)', wordBreak: 'break-all' }}>{value}</div>
      {hint && <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 2 }}>{hint}</div>}
    </div>
  );
}
